import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent {
  public IsLoading = false;
  public ShowPassword = false;

  constructor(private authService: AuthService, private sharedService: SharedService, router: Router) {
    if (this.sharedService.isUserSignedIn()) router.navigate(['/home']);
  }

  SigninForm: FormGroup<any> = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required])
  });

  async signin() {
    this.IsLoading = true;
    const response = await this.authService.signIn(this.SigninForm.value);

    response.subscribe({
      next: (res) => {
        const { token, tokenExpired, ...userdetails } = res.result;
        this.sharedService.setData('token', token, tokenExpired);
        this.sharedService.setData('userdetails', userdetails);
        this.sharedService.setUserLoggedIn(true);
        this.sharedService.UserDetails.next(userdetails);
        this.sharedService.CurrentClinic.next(userdetails.clinicId);
      },
      error: (err) => {
        this.IsLoading = false;
      },
      complete: () => (this.IsLoading = false)
    });
  }
}
